import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ManagementApiService } from '../management-api.service';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs';
import { ManagementStoreService } from '../management-store.service';
import {NutritionActions} from '@emm/management/store/nutrition/nutrition.actions';

@Injectable({ providedIn: 'root' })
export class NutritionEffects {

    constructor(
        private actions$: Actions,
        private api: ManagementApiService,
        private store: ManagementStoreService
    ) {}

    loadAssignments$ = createEffect(() =>
        this.actions$.pipe(
            ofType(NutritionActions.loadAssignments),
            withLatestFrom(this.store.queryNutrition.location$),
            switchMap(([_, location]) =>
                this.api.getNutritionAssignments(location.tag).pipe(
                    map((assignments) => NutritionActions.loadAssignmentsSuccess({ assignments })),
                    catchError(({ error }) => of(NutritionActions.loadAssignmentsFailure({ error })))
                )
            )
        )
    );

    loadProfiles$ = createEffect(() =>
        this.actions$.pipe(
            ofType(NutritionActions.loadProfileOptions),
            switchMap(() =>
                this.api.getProfileOptions().pipe(
                    map((profileOptions) => NutritionActions.loadProfileOptionsSuccess({ profileOptions })),
                    catchError(({ error }) => of(NutritionActions.loadProfileOptionsFailure({ error })))
                )
            )
        )
    );

    saveLocationAssignment$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(NutritionActions.saveLocationAssignment),
            switchMap(({ apiData }) => {
                const responseData = {
                    ...apiData,
                    effectiveTime: apiData.effectiveDate
                };
                return this.api.saveLocationAssignment(apiData).pipe(
                    map((profileOptions) => NutritionActions.saveLocationAssignmentSuccess({ apiData: responseData })),
                    catchError(({error}) => of(NutritionActions.saveLocationAssignmentFailure({ error })))
                );
            })
        );
    });

}
